module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.router && _vm.router.name) ? _c('router-link', {
    staticClass: "treeview",
    attrs: {
      "tag": "li",
      "to": _vm.router
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    class: _vm.icon
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "width": "228px",
      "background": "#183764"
    }
  }, [_vm._v(_vm._s(_vm.name))])])]) : _c('li', {
    class: _vm.getType
  }, [_vm._v("\n  " + _vm._s(_vm.isHeader ? _vm.name : '') + "\n  "), (_vm.window.width < 770) ? _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    class: _vm.icon
  }), _vm._v(" "), _c('span', {
    staticClass: "side-sub"
  }, [_vm._v(_vm._s(_vm.name))])]) : _vm._e(), _vm._v(" "), (!_vm.isHeader && _vm.window.width > 770) ? _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    class: _vm.icon
  }), _vm._v(" "), _c('span', {
    staticClass: "side-sub"
  }, [_vm._v(_vm._s(_vm.name))])]) : _vm._e(), _vm._v(" "), (_vm.items.length > 0) ? _c('ul', {
    staticClass: "treeview-menu",
    staticStyle: {
      "width": "228px"
    },
    attrs: {
      "id": "treeMenu"
    }
  }, _vm._l((_vm.items), function(item, index) {
    return (item.router && item.router.name) ? _c('router-link', {
      key: index,
      attrs: {
        "tag": "li",
        "data": item,
        "to": item.router
      }
    }, [_c('a', [_c('i', {
      class: item.icon
    }), _vm._v(" " + _vm._s(item.name) + "\n      ")])]) : _c('li', [_c('a', [_c('i', {
      class: item.icon
    }), _vm._v(" " + _vm._s(item.name) + "\n      ")])])
  }), 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-76a80040!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/navigation/VASlideItem.vue
// module id = 531
// module chunks = 1